// extracted by mini-css-extract-plugin
export default {"aboutUsItem":"AboutUsItem_aboutUsItem__BE4Ct"};